import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function DDM() {
  const { t } = useTranslation(); // 預設使用 translation namespace

  return (
    <div className="article-container">
      <h1>{t('ddm.title')}</h1>
      <p dangerouslySetInnerHTML={{ __html: t('ddm.paragraph1') }} />

      <h3>{t('ddm.whyUseHeading')}</h3>
      <p>{t('ddm.paragraph2')}</p>
      <ul>
        <li>
          <strong>{t('ddm.bullet1.label')}</strong> {t('ddm.bullet1.text')}
        </li>
        <li>
          <strong>{t('ddm.bullet2.label')}</strong> {t('ddm.bullet2.text')}
        </li>
      </ul>

      <h3>{t('ddm.howWorksHeading')}</h3>
      <p>{t('ddm.paragraph3')}</p>
      <p>
        <strong>{t('ddm.ddmFormulaLabel')}</strong>
        <br />
        {t('ddm.ddmFormula')}
      </p>
      <p>
        <strong>{t('ddm.forExampleLabel')}</strong> {t('ddm.exampleParagraph')}
      </p>
      <p>{t('ddm.exampleConclusion')}</p>

      <h3>{t('ddm.whyImportantHeading')}</h3>
      <p>{t('ddm.paragraph4')}</p>
      <ul>
        <li>
          <strong>{t('ddm.whyImportantList.dividendSustain.label')}</strong>{' '}
          {t('ddm.whyImportantList.dividendSustain.text')}
        </li>
        <li>
          <strong>{t('ddm.whyImportantList.fairValue.label')}</strong>{' '}
          {t('ddm.whyImportantList.fairValue.text')}
        </li>
      </ul>

      <h3>{t('ddm.whenUseHeading')}</h3>
      <p>{t('ddm.paragraph5')}</p>

      <h3>{t('ddm.exampleHeading')}</h3>
      <p>{t('ddm.exampleParagraph2')}</p>
      <ol>
        <li>{t('ddm.exampleList.dividendCalc')}</li>
        <li>{t('ddm.exampleList.stockValueCalc')}</li>
      </ol>
      <p>{t('ddm.exampleConclusion2')}</p>

      <h3>{t('ddm.finalThoughtHeading')}</h3>
      <p>{t('ddm.finalThoughtParagraph')}</p>
      <ul>
        <li>
          <strong>{t('ddm.limitationList.unpredictable.label')}</strong>{' '}
          {t('ddm.limitationList.unpredictable.text')}
        </li>
        <li>
          <strong>{t('ddm.limitationList.growthRates.label')}</strong>{' '}
          {t('ddm.limitationList.growthRates.text')}
        </li>
      </ul>
      <p>{t('ddm.finalThoughtParagraph2')}</p>
    </div>
  );
}

export default DDM;
